module.exports = __webpack_public_path__ + "static/media/empty-star.99aef3a5.svg";